import { BookingStatistic } from '../types/booking-statistic';
import { ContentView } from '../types/content-view';
import { BookingStatisticDate } from '../types/interfaces/booking-statistic-date';
import { StatisticsVariant } from '../types/statistic-variant';

export const groupBookingStatistics = (
  data: BookingStatisticDate[],
  variant: StatisticsVariant,
  contentView: ContentView,
): {
  grouped: BookingStatistic[];
  floors: number[];
} => {
  if (data?.length === 0) return { grouped: [], floors: [] };
  const grouped: Record<string, BookingStatistic> = {};
  const floorSet = new Set<number>();

  for (const item of data) {
    const { date: fullDate, spaceType, total, spaceFloor } = item;
    const date =
      variant === 'MONTHLY' && contentView === 'TABLE'
        ? fullDate.slice(0, 7)
        : fullDate;

    floorSet.add(spaceFloor);

    if (!grouped[date]) {
      grouped[date] = {
        date,
        ROOM: 0,
        DESK: 0,
        spaceFloors: {},
      };
    }

    grouped[date][spaceType] += total;

    if (!grouped[date].spaceFloors[spaceFloor]) {
      grouped[date].spaceFloors[spaceFloor] = {
        ROOM: 0,
        DESK: 0,
      };
    }

    grouped[date].spaceFloors[spaceFloor][spaceType] += total;
  }
  return {
    grouped: Object.values(grouped) || [],
    floors: Array.from(floorSet).sort((a, b) => a - b) || [],
  };
};
